// extracted by mini-css-extract-plugin
module.exports = {"readMore":"read-more_readMore__2IRO2"};